<script lang="ts" context="module">
  // @ts-nocheck
  import AccessTime from "@shared/svelte/Icons/AccessTime.svg";
  import AccountSettingsGear from "@shared/svelte/Icons/AccountSettingsGear.svg";
  import ACH from "@shared/svelte/Icons/ACH.svg";
  import ActionBarDistributors from "@shared/svelte/Icons/ActionBarDistributors.svg";
  import ActionBarOrderHistory from "@shared/svelte/Icons/ActionBarOrderHistory.svg";
  import Alert from "@shared/svelte/Icons/Alert.svg";
  import ArrowDown from "@shared/svelte/Icons/ArrowDown.svg";
  import ArrowheadRight from "@shared/svelte/Icons/ArrowheadRight.svg";
  import ArrowLeft from "@shared/svelte/Icons/ArrowLeft.svg";
  import ArrowRight from "@shared/svelte/Icons/ArrowRight.svg";
  import ArrowSpinnable from "@shared/svelte/Icons/ArrowSpinnable.svg";
  import ArrowUp from "@shared/svelte/Icons/ArrowUp.svg";
  import BarGraph from "@shared/svelte/Icons/BarGraph.svg";
  import Bell from "@shared/svelte/Icons/Bell.svg";
  import Beverages from "@shared/svelte/Icons/Beverages.svg";
  import Bottle from "@shared/svelte/Icons/Bottle.svg";
  import BottleCase from "@shared/svelte/Icons/BottleCase.svg";
  import Box from "@shared/svelte/Icons/Box.svg";
  import Bubbles from "@shared/svelte/Icons/Bubbles.svg";
  import Calendar from "@shared/svelte/Icons/Calendar.svg";
  import CalendarToday from "@shared/svelte/Icons/CalendarToday.svg";
  import Can from "@shared/svelte/Icons/Can.svg";
  import CancelCircle from "@shared/svelte/Icons/CancelCircle.svg";
  import Cart from "@shared/svelte/Icons/Cart.svg";
  import CartArrowUp from "@shared/svelte/Icons/CartArrowUp.svg";
  import Cash from "@shared/svelte/Icons/Cash.svg";
  import ChatBubble from "@shared/svelte/Icons/ChatBubble.svg";
  import CheckCircle from "@shared/svelte/Icons/CheckCircle.svg";
  import ChevronDown from "@shared/svelte/Icons/ChevronDown.svg";
  import ChevronLeft from "@shared/svelte/Icons/ChevronLeft.svg";
  import ChevronRight from "@shared/svelte/Icons/ChevronRight.svg";
  import CirclePayments from "@shared/svelte/Icons/CirclePayments.svg";
  import CircularArrows from "@shared/svelte/Icons/CircularArrows.svg";
  import Clipboard from "@shared/svelte/Icons/Clipboard.svg";
  import Clock from "@shared/svelte/Icons/Clock.svg";
  import ClockAfternoon from "@shared/svelte/Icons/ClockAfternoon.svg";
  import Close from "@shared/svelte/Icons/Close.svg";
  import Coin from "@shared/svelte/Icons/Coin.svg";
  import Containers from "@shared/svelte/Icons/Containers.svg";
  import Copy from "@shared/svelte/Icons/Copy.svg";
  import CreditsBrand from "@shared/svelte/Icons/CreditsBrand.svg";
  import CreditsColor from "@shared/svelte/Icons/CreditsColor.svg";
  import CreditsGray from "@shared/svelte/Icons/CreditsGray.svg";
  import Deal from "@shared/svelte/Icons/Deal.svg";
  import DealBack from "@shared/svelte/Icons/DealBack.svg";
  import DealCircled from "@shared/svelte/Icons/DealCircled.svg";
  import DealNote from "@shared/svelte/Icons/DealNote.svg";
  import DealSatisfied from "@shared/svelte/Icons/DealSatisfied.svg";
  import Desktop from "@shared/svelte/Icons/Desktop.svg";
  import DistributorLogoPlaceholder from "@shared/svelte/Icons/DistributorLogoPlaceholder.svg";
  import DistributorName from "@shared/svelte/Icons/DistributorName.svg";
  import DistributorTruck from "@shared/svelte/Icons/DistributorTruck.svg";
  import DistributorTruckOrange from "@shared/svelte/Icons/DistributorTruckOrange.svg";
  import Document from "@shared/svelte/Icons/Document.svg";
  import Dollar from "@shared/svelte/Icons/Dollar.svg";
  import DollarRound from "@shared/svelte/Icons/DollarRound.svg";
  import DoubleArrow from "@shared/svelte/Icons/DoubleArrow.svg";
  import DownArrow from "@shared/svelte/Icons/DownArrow.svg";
  import Edit from "@shared/svelte/Icons/Edit.svg";
  import Enroll from "@shared/svelte/Icons/Enroll.svg";
  import ErrorBlack from "@shared/svelte/Icons/ErrorBlack.svg";
  import Error from "@shared/svelte/Icons/Error.svg";
  import EventTracking from "@shared/svelte/Icons/EventTrocking.svg";
  import Eye from "@shared/svelte/Icons/Eye.svg";
  import EyeClosed from "@shared/svelte/Icons/EyeClosed.svg";
  import FacebookCircle from "@shared/svelte/Icons/FacebookCircle.svg";
  import FAQ from "@shared/svelte/Icons/FAQ.svg";
  import File from "@shared/svelte/Icons/File.svg";
  import Filter from "@shared/svelte/Icons/Filter.svg";
  import Filter2 from "@shared/svelte/Icons/Filter2.svg";
  import FilterList from "@shared/svelte/Icons/FilterList.svg";
  import GiftBox from "@shared/svelte/Icons/GiftBox.svg";
  import GrabHandle from "@shared/svelte/Icons/GrabHandle.svg";
  import Highlight from "@shared/svelte/Icons/Highlight.svg";
  import HighlightArrow from "@shared/svelte/Icons/HighlightArrow.svg";
  import History from "@shared/svelte/Icons/History.svg";
  import Image from "@shared/svelte/Icons/Image.svg";
  import Info from "@shared/svelte/Icons/Info.svg";
  import InfoYellow from "@shared/svelte/Icons/InfoYellow.svg";
  import InfoGray from "@shared/svelte/Icons/InfoGray.svg";
  import InfoOutline from "@shared/svelte/Icons/InfoOutline.svg";
  import Integrated from "@shared/svelte/Icons/Integrated.svg";
  import InstagramCircle from "@shared/svelte/Icons/InstagramCircle.svg";
  import Invoice from "@shared/svelte/Icons/Invoice.svg";
  import InvoiceOn from "@shared/svelte/Icons/InvoiceOn.svg";
  import Keg from "@shared/svelte/Icons/Keg.svg";
  import LayoutGrid from "@shared/svelte/Icons/LayoutGrid.svg";
  import LayoutList from "@shared/svelte/Icons/LayoutList.svg";
  import LifePreserver from "@shared/svelte/Icons/LifePreserver.svg";
  import Lightbulb from "@shared/svelte/Icons/Lightbulb.svg";
  import Lists from "@shared/svelte/Icons/Lists.svg";
  import ListsGreen from "@shared/svelte/Icons/ListsGreen.svg";
  import LittleBottle from "@shared/svelte/Icons/LittleBottle.svg";
  import Location from "@shared/svelte/Icons/Location.svg";
  import LocationPin from "@shared/svelte/Icons/LocationPin.svg";
  import Lock from "@shared/svelte/Icons/Lock.svg";
  import Logout from "@shared/svelte/Icons/Logout.svg";
  import MartiniGlass from "@shared/svelte/Icons/MartiniGlass.svg";
  import Megaphone from "@shared/svelte/Icons/Megaphone.svg";
  import Menu from "@shared/svelte/Icons/Menu.svg";
  import MenuSmall from "@shared/svelte/Icons/MenuSmall.svg";
  import Message from "@shared/svelte/Icons/Message.svg";
  import MessageArrow from "@shared/svelte/Icons/MessageArrow.svg";
  import Mobile from "@shared/svelte/Icons/Mobile.svg";
  import MoneyOff from "@shared/svelte/Icons/MoneyOff.svg";
  import More from "@shared/svelte/Icons/More.svg";
  import MoreVert from "@shared/svelte/Icons/MoreVert.svg";
  import MoreVertical from "@shared/svelte/Icons/MoreVertical.svg";
  import NewProducts from "@shared/svelte/Icons/NewProducts.svg";
  import Notes from "@shared/svelte/Icons/Notes.svg";
  import Notification from "@shared/svelte/Icons/Notification.svg";
  import Onboard from "@shared/svelte/Icons/Onboard.svg";
  import OpenExternalLink from "@shared/svelte/Icons/OpenExternalLink.svg";
  import OrderHistory from "@shared/svelte/Icons/OrderHistory.svg";
  import PaintBrush from "@shared/svelte/Icons/PaintBrush.svg";
  import Pencil from "@shared/svelte/Icons/Pencil.svg";
  import Plus from "@shared/svelte/Icons/Plus.svg";
  import PlusBlack from "@shared/svelte/Icons/PlusBlack.svg";
  import ProductRequests from "@shared/svelte/Icons/ProductRequests.svg";
  import ProviChat from "@shared/svelte/Icons/ProviChat.svg";
  import ProviHeroBlue from "@shared/svelte/Icons/ProviHeroBlue.svg";
  import ProviLogo from "@shared/svelte/Icons/ProviLogo.svg";
  import ProviPay from "@shared/svelte/Icons/ProviPay.svg";
  import Question from "@shared/svelte/Icons/Question.svg";
  import QuestionCircle from "@shared/svelte/Icons/QuestionCircle.svg";
  import QuestionFilled from "@shared/svelte/Icons/QuestionFilled.svg";
  import QuestionSquare from "@shared/svelte/Icons/QuestionSquare.svg";
  import Save from "@shared/svelte/Icons/Save.svg";
  import Search from "@shared/svelte/Icons/Search.svg";
  import SellSheets from "@shared/svelte/Icons/SellSheets.svg";
  import SettingsGear from "@shared/svelte/Icons/SettingsGear.svg";
  import SettingsGearFilled from "@shared/svelte/Icons/SettingsGearFilled.svg";
  import ShoppingBag from "@shared/svelte/Icons/ShoppingBag.svg";
  import SocialCircle from "@shared/svelte/Icons/SocialCircle.svg";
  import Sort from "@shared/svelte/Icons/Sort.svg";
  import SortArrow from "@shared/svelte/Icons/SortArrow.svg";
  import Stars from "@shared/svelte/Icons/Stars.svg";
  import Statement from "@shared/svelte/Icons/Statement.svg";
  import StatementCircle from "@shared/svelte/Icons/StatementCircle.svg";
  import Storefront from "@shared/svelte/Icons/Storefront.svg";
  import Tick from "@shared/svelte/Icons/Tick.svg";
  import Timer from "@shared/svelte/Icons/Timer.svg";
  import Trash from "@shared/svelte/Icons/Trash.svg";
  import Truck from "@shared/svelte/Icons/Truck.svg";
  import TruckCircle from "@shared/svelte/Icons/TruckCircle.svg";
  import TwitterCircle from "@shared/svelte/Icons/TwitterCircle.svg";
  import UpArrow from "@shared/svelte/Icons/UpArrow.svg";
  import UpDownArrows from "@shared/svelte/Icons/UpDownArrows.svg";
  import User from "@shared/svelte/Icons/User.svg";
  import Users from "@shared/svelte/Icons/Users.svg";
  import VerifiedInStock from "@shared/svelte/Icons/VerifiedInStock.svg";
  import Warning from "@shared/svelte/Icons/Warning.svg";
  import X from "@shared/svelte/Icons/X.svg";

  export function iconLookup(iconType: string) {
    return {
      AccessTime,
      AccountSettingsGear,
      ACH,
      ActionBarDistributors,
      ActionBarOrderHistory,
      Alert,
      ArrowDown,
      ArrowheadRight,
      ArrowLeft,
      ArrowRight,
      ArrowSpinnable,
      ArrowUp,
      BarGraph,
      Bell,
      Beverages,
      Bottle,
      BottleCase,
      Box,
      Bubbles,
      Calendar,
      CalendarToday,
      Can,
      CancelCircle,
      Cart,
      CartArrowUp,
      Cash,
      ChatBubble,
      CheckCircle,
      ChevronDown,
      ChevronLeft,
      ChevronRight,
      CirclePayments,
      CircularArrows,
      Clipboard,
      Clock,
      ClockAfternoon,
      Close,
      Coin,
      Containers,
      Copy,
      CreditsBrand,
      CreditsColor,
      CreditsGray,
      Deal,
      DealBack,
      DealCircled,
      DealNote,
      DealSatisfied,
      Desktop,
      DistributorLogoPlaceholder,
      DistributorName,
      DistributorTruck,
      DistributorTruckOrange,
      Document,
      Dollar,
      DollarRound,
      DoubleArrow,
      DownArrow,
      Edit,
      Enroll,
      ErrorBlack,
      Error,
      EventTracking,
      Eye,
      EyeClosed,
      FacebookCircle,
      FAQ,
      File,
      Filter,
      Filter2,
      FilterList,
      GiftBox,
      GrabHandle,
      Highlight,
      HighlightArrow,
      History,
      Image,
      Info,
      InfoYellow,
      InfoGray,
      InfoOutline,
      Integrated,
      InstagramCircle,
      Invoice,
      InvoiceOn,
      Keg,
      LayoutGrid,
      LayoutList,
      LifePreserver,
      Lightbulb,
      Lists,
      ListsGreen,
      LittleBottle,
      Location,
      LocationPin,
      Lock,
      Logout,
      MartiniGlass,
      Megaphone,
      Menu,
      MenuSmall,
      Message,
      MessageArrow,
      Mobile,
      MoneyOff,
      More,
      MoreVert,
      MoreVertical,
      NewProducts,
      Notes,
      Notification,
      Onboard,
      OpenExternalLink,
      OrderHistory,
      PaintBrush,
      Pencil,
      Plus,
      PlusBlack,
      ProductRequests,
      ProviChat,
      ProviHeroBlue,
      ProviLogo,
      ProviPay,
      Question,
      QuestionCircle,
      QuestionFilled,
      QuestionSquare,
      Save,
      Search,
      SellSheets,
      SettingsGear,
      SettingsGearFilled,
      ShoppingBag,
      SocialCircle,
      Sort,
      SortArrow,
      Stars,
      Statement,
      StatementCircle,
      Storefront,
      Tick,
      Timer,
      Trash,
      Truck,
      TruckCircle,
      TwitterCircle,
      UpArrow,
      UpDownArrows,
      User,
      Users,
      VerifiedInStock,
      Warning,
      X,
    }[iconType];
  }
</script>
